// External Libraries
import React, { useState, useEffect } from "react";
import axios from "axios";
import { CSVLink } from "react-csv";

// Material-UI Components
import { Container, Card, CardContent } from '@mui/material';
import Grid from '@mui/material/Grid2';

// Internal Components
import MainTable from "../table/MainTable";

/************* Tebra Encounters Table *************/

const TebraEncounters = () => {
  const [tebraEncountersData, setTebraEncountersData] = useState([]);
  const [pagination, setPagination] = useState({ pageIndex: 1, pageSize: 10, totalPages: 1 });

  const fetchPatientsEncounters = async (pageIndex) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_APIS_BASE_URL}/api/charges?page=${pageIndex}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        }
      );
      setTebraEncountersData(response.data.data.data);
      setPagination((prev) => ({
        ...prev,
        pageIndex: response.data.data.current_page,
        totalPages: response.data.data.last_page,
      }));
    } catch (err) {
      console.error("Error fetching patients:", err);
    }
  };

  useEffect(() => {
    fetchPatientsEncounters(pagination.pageIndex);
  }, [pagination.pageIndex]);

  const handlePageChange = (newPageIndex) => {
    if (typeof newPageIndex === 'object' && newPageIndex.hasOwnProperty('pageIndex')) {
      newPageIndex = newPageIndex.pageIndex;
    }

    if (typeof newPageIndex === 'number' && !isNaN(newPageIndex)) {
      setPagination((prev) => ({
        ...prev,
        pageIndex: newPageIndex + 1,
      }));
    } else {
      console.error("Invalid page index passed:", newPageIndex);
    }
  };

  const columns = [
    {
      accessorKey: 'EncounterID',
      header: 'EncounterID',
    },
    {
      accessorKey: 'PatientID',
      header: 'PatientID',
    },
    {
      accessorKey: 'PatientName',
      header: 'PatientName',
    },
    {
      accessorKey: 'PatientDateOfBirth',
      header: 'PatientDateOfBirth',
    },
    {
      accessorKey: 'CaseName',
      header: 'CaseName',
    },
    {
      accessorKey: 'CasePayerScenario',
      header: 'CasePayerScenario',
    },
    {
      accessorKey: 'ServiceStartDate',
      header: 'ServiceStartDate',
    },
    {
      accessorKey: 'ServiceEndDate',
      header: 'ServiceEndDate',
    },
    {
      accessorKey: 'PostingDate',
      header: 'PostingDate',
    },
    {
      accessorKey: 'ProcedureCode',
      header: 'ProcedureCode',
    },
    {
      accessorKey: 'ProcedureName',
      header: 'ProcedureName',
    },
    {
      accessorKey: 'ProcedureModifier1',
      header: 'ProcedureModifier1',
    },
    {
      accessorKey: 'ProcedureModifier2',
      header: 'ProcedureModifier2',
    },
    {
      accessorKey: 'ProcedureModifier3',
      header: 'ProcedureModifier3',
    },
    {
      accessorKey: 'ProcedureModifier4',
      header: 'ProcedureModifier4',
    },
    {
      accessorKey: 'DiagnosisCode1',
      header: 'DiagnosisCode1',
    },
    {
      accessorKey: 'DiagnosisCode2',
      header: 'DiagnosisCode2',
    },
    {
      accessorKey: 'DiagnosisCode3',
      header: 'DiagnosisCode3',
    },
    {
      accessorKey: 'DiagnosisCode4',
      header: 'DiagnosisCode4',
    },
    {
      accessorKey: 'Units',
      header: 'Units',
    },
  ];

  /* const csvData = tebraEncountersData.map(patient => {
    const row = {};
    columns.forEach(column => {
      row[column.header] = patient[column.accessorKey] || '';
    });
    return row;
  });

  const renderTopToolbarCustomActions = () => (
    <div className="d-flex gap-2">
      <CSVLink
        data={csvData}
        filename={"patients_data.csv"}
        className="btn btn-primary light btn-sm"
      >
        <i className="fa-solid fa-file-excel me-2" />
        Export Report
      </CSVLink>
    </div>
  ); */

  return (
    <>
      <Container maxWidth="xxl" sx={{ padding: '1.875rem 1.875rem 0' }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Card elevation={0} sx={{ borderRadius: '12px' }}>
              <CardContent>
                <MainTable
                  data={tebraEncountersData}
                  columns={columns}
                  title="Tebra Encounters"

                  enableRowSelection={false}
                  enableColumnFilters={true}
                  enableGlobalFilter={true}
                  enablePagination={true}
                  enableSorting={true}
                  enableGrouping={true}
                  manualPaginationMode={true}
                  paginationDisplayMode="pages"
                  currentPage={pagination.pageIndex - 1}
                  totalPages={pagination.totalPages}
                  onPageChange={handlePageChange}

                  enableStickyHeader={true}
                  enableStickyFooter={true}
                  enableColumnResizing={true}
                  enableHiding={true}

                  rowsPerPageOptions={[10, 25, 50, 100]}
                  initialPageSize={10}

                  // renderTopToolbarCustomActions={renderTopToolbarCustomActions}

                  muiTablePaperProps={{
                    sx: {
                      boxShadow: 'none',
                    }
                  }}
                />
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default TebraEncounters;
